"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Address = _interopRequireDefault(require("./Address"));

var _PurchaseOrderCustomData = _interopRequireDefault(require("./PurchaseOrderCustomData"));

var _PurchaseOrderLineItem = _interopRequireDefault(require("./PurchaseOrderLineItem"));

var _SlimUser = _interopRequireDefault(require("./SlimUser"));

var _StopAlert = _interopRequireDefault(require("./StopAlert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The PurchaseOrder model module.
 * @module model/PurchaseOrder
 * @version 2.7.64
 */
var PurchaseOrder = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>PurchaseOrder</code>.
   * @alias module:model/PurchaseOrder
   * @param destinationAddress {module:model/Address} 
   * @param orderNumber {String} 
   * @param originAddress {module:model/Address} 
   * @param source {module:model/PurchaseOrder.SourceEnum} 
   */
  function PurchaseOrder(destinationAddress, orderNumber, originAddress, source) {
    _classCallCheck(this, PurchaseOrder);

    PurchaseOrder.initialize(this, destinationAddress, orderNumber, originAddress, source);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(PurchaseOrder, null, [{
    key: "initialize",
    value: function initialize(obj, destinationAddress, orderNumber, originAddress, source) {
      obj['destination_address'] = destinationAddress;
      obj['order_number'] = orderNumber;
      obj['origin_address'] = originAddress;
      obj['source'] = source;
    }
    /**
     * Constructs a <code>PurchaseOrder</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PurchaseOrder} obj Optional instance to populate.
     * @return {module:model/PurchaseOrder} The populated <code>PurchaseOrder</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new PurchaseOrder();

        if (data.hasOwnProperty('actual_delivery_datetime')) {
          obj['actual_delivery_datetime'] = _ApiClient["default"].convertToType(data['actual_delivery_datetime'], 'Date');
        }

        if (data.hasOwnProperty('actual_pickup_datetime')) {
          obj['actual_pickup_datetime'] = _ApiClient["default"].convertToType(data['actual_pickup_datetime'], 'Date');
        }

        if (data.hasOwnProperty('archived')) {
          obj['archived'] = _ApiClient["default"].convertToType(data['archived'], 'Boolean');
        }

        if (data.hasOwnProperty('company')) {
          obj['company'] = _ApiClient["default"].convertToType(data['company'], 'String');
        }

        if (data.hasOwnProperty('created_at')) {
          obj['created_at'] = _ApiClient["default"].convertToType(data['created_at'], 'Date');
        }

        if (data.hasOwnProperty('created_by_user')) {
          obj['created_by_user'] = _SlimUser["default"].constructFromObject(data['created_by_user']);
        }

        if (data.hasOwnProperty('custom_data')) {
          obj['custom_data'] = _PurchaseOrderCustomData["default"].constructFromObject(data['custom_data']);
        }

        if (data.hasOwnProperty('customer_external_id')) {
          obj['customer_external_id'] = _ApiClient["default"].convertToType(data['customer_external_id'], 'String');
        }

        if (data.hasOwnProperty('customer_name')) {
          obj['customer_name'] = _ApiClient["default"].convertToType(data['customer_name'], 'String');
        }

        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }

        if (data.hasOwnProperty('destination_address')) {
          obj['destination_address'] = _Address["default"].constructFromObject(data['destination_address']);
        }

        if (data.hasOwnProperty('destination_address_book_entry')) {
          obj['destination_address_book_entry'] = _ApiClient["default"].convertToType(data['destination_address_book_entry'], 'String');
        }

        if (data.hasOwnProperty('destination_dock_external_id')) {
          obj['destination_dock_external_id'] = _ApiClient["default"].convertToType(data['destination_dock_external_id'], 'String');
        }

        if (data.hasOwnProperty('destination_stop')) {
          obj['destination_stop'] = _ApiClient["default"].convertToType(data['destination_stop'], 'String');
        }

        if (data.hasOwnProperty('destination_stop_alerts')) {
          obj['destination_stop_alerts'] = _ApiClient["default"].convertToType(data['destination_stop_alerts'], [_StopAlert["default"]]);
        }

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'String');
        }

        if (data.hasOwnProperty('invoice_external_id')) {
          obj['invoice_external_id'] = _ApiClient["default"].convertToType(data['invoice_external_id'], 'String');
        }

        if (data.hasOwnProperty('line_items')) {
          obj['line_items'] = _ApiClient["default"].convertToType(data['line_items'], [_PurchaseOrderLineItem["default"]]);
        }

        if (data.hasOwnProperty('name')) {
          obj['name'] = _ApiClient["default"].convertToType(data['name'], 'String');
        }

        if (data.hasOwnProperty('order_number')) {
          obj['order_number'] = _ApiClient["default"].convertToType(data['order_number'], 'String');
        }

        if (data.hasOwnProperty('origin_address')) {
          obj['origin_address'] = _Address["default"].constructFromObject(data['origin_address']);
        }

        if (data.hasOwnProperty('origin_address_book_entry')) {
          obj['origin_address_book_entry'] = _ApiClient["default"].convertToType(data['origin_address_book_entry'], 'String');
        }

        if (data.hasOwnProperty('origin_dock_external_id')) {
          obj['origin_dock_external_id'] = _ApiClient["default"].convertToType(data['origin_dock_external_id'], 'String');
        }

        if (data.hasOwnProperty('origin_stop')) {
          obj['origin_stop'] = _ApiClient["default"].convertToType(data['origin_stop'], 'String');
        }

        if (data.hasOwnProperty('origin_stop_alerts')) {
          obj['origin_stop_alerts'] = _ApiClient["default"].convertToType(data['origin_stop_alerts'], [_StopAlert["default"]]);
        }

        if (data.hasOwnProperty('overall_status')) {
          obj['overall_status'] = _ApiClient["default"].convertToType(data['overall_status'], 'String');
        }

        if (data.hasOwnProperty('planned_delivery_end_datetime')) {
          obj['planned_delivery_end_datetime'] = _ApiClient["default"].convertToType(data['planned_delivery_end_datetime'], 'Date');
        }

        if (data.hasOwnProperty('planned_delivery_start_datetime')) {
          obj['planned_delivery_start_datetime'] = _ApiClient["default"].convertToType(data['planned_delivery_start_datetime'], 'Date');
        }

        if (data.hasOwnProperty('planned_pickup_end_datetime')) {
          obj['planned_pickup_end_datetime'] = _ApiClient["default"].convertToType(data['planned_pickup_end_datetime'], 'Date');
        }

        if (data.hasOwnProperty('planned_pickup_start_datetime')) {
          obj['planned_pickup_start_datetime'] = _ApiClient["default"].convertToType(data['planned_pickup_start_datetime'], 'Date');
        }

        if (data.hasOwnProperty('purchase_order_number')) {
          obj['purchase_order_number'] = _ApiClient["default"].convertToType(data['purchase_order_number'], 'String');
        }

        if (data.hasOwnProperty('shipment')) {
          obj['shipment'] = _ApiClient["default"].convertToType(data['shipment'], 'String');
        }

        if (data.hasOwnProperty('source')) {
          obj['source'] = _ApiClient["default"].convertToType(data['source'], 'String');
        }

        if (data.hasOwnProperty('source_system_id')) {
          obj['source_system_id'] = _ApiClient["default"].convertToType(data['source_system_id'], 'String');
        }

        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'String');
        }

        if (data.hasOwnProperty('subtotal_amount')) {
          obj['subtotal_amount'] = _ApiClient["default"].convertToType(data['subtotal_amount'], 'Number');
        }

        if (data.hasOwnProperty('subtotal_amount_currency')) {
          obj['subtotal_amount_currency'] = _ApiClient["default"].convertToType(data['subtotal_amount_currency'], 'String');
        }

        if (data.hasOwnProperty('supplier_external_id')) {
          obj['supplier_external_id'] = _ApiClient["default"].convertToType(data['supplier_external_id'], 'String');
        }

        if (data.hasOwnProperty('supplier_name')) {
          obj['supplier_name'] = _ApiClient["default"].convertToType(data['supplier_name'], 'String');
        }

        if (data.hasOwnProperty('tax_amount')) {
          obj['tax_amount'] = _ApiClient["default"].convertToType(data['tax_amount'], 'Number');
        }

        if (data.hasOwnProperty('tax_amount_currency')) {
          obj['tax_amount_currency'] = _ApiClient["default"].convertToType(data['tax_amount_currency'], 'String');
        }

        if (data.hasOwnProperty('transit_status')) {
          obj['transit_status'] = _ApiClient["default"].convertToType(data['transit_status'], 'String');
        }

        if (data.hasOwnProperty('transit_status_reason_code')) {
          obj['transit_status_reason_code'] = _ApiClient["default"].convertToType(data['transit_status_reason_code'], 'String');
        }

        if (data.hasOwnProperty('updated_at')) {
          obj['updated_at'] = _ApiClient["default"].convertToType(data['updated_at'], 'Date');
        }
      }

      return obj;
    }
  }]);

  return PurchaseOrder;
}();
/**
 * @member {Date} actual_delivery_datetime
 */


PurchaseOrder.prototype['actual_delivery_datetime'] = undefined;
/**
 * @member {Date} actual_pickup_datetime
 */

PurchaseOrder.prototype['actual_pickup_datetime'] = undefined;
/**
 * @member {Boolean} archived
 */

PurchaseOrder.prototype['archived'] = undefined;
/**
 * @member {String} company
 */

PurchaseOrder.prototype['company'] = undefined;
/**
 * @member {Date} created_at
 */

PurchaseOrder.prototype['created_at'] = undefined;
/**
 * @member {module:model/SlimUser} created_by_user
 */

PurchaseOrder.prototype['created_by_user'] = undefined;
/**
 * @member {module:model/PurchaseOrderCustomData} custom_data
 */

PurchaseOrder.prototype['custom_data'] = undefined;
/**
 * @member {String} customer_external_id
 */

PurchaseOrder.prototype['customer_external_id'] = undefined;
/**
 * @member {String} customer_name
 */

PurchaseOrder.prototype['customer_name'] = undefined;
/**
 * @member {String} description
 */

PurchaseOrder.prototype['description'] = undefined;
/**
 * @member {module:model/Address} destination_address
 */

PurchaseOrder.prototype['destination_address'] = undefined;
/**
 * @member {String} destination_address_book_entry
 */

PurchaseOrder.prototype['destination_address_book_entry'] = undefined;
/**
 * Destination dock id of the purchase order from the company's external system
 * @member {String} destination_dock_external_id
 */

PurchaseOrder.prototype['destination_dock_external_id'] = undefined;
/**
 * @member {String} destination_stop
 */

PurchaseOrder.prototype['destination_stop'] = undefined;
/**
 * @member {Array.<module:model/StopAlert>} destination_stop_alerts
 */

PurchaseOrder.prototype['destination_stop_alerts'] = undefined;
/**
 * @member {String} id
 */

PurchaseOrder.prototype['id'] = undefined;
/**
 * @member {String} invoice_external_id
 */

PurchaseOrder.prototype['invoice_external_id'] = undefined;
/**
 * @member {Array.<module:model/PurchaseOrderLineItem>} line_items
 */

PurchaseOrder.prototype['line_items'] = undefined;
/**
 * @member {String} name
 */

PurchaseOrder.prototype['name'] = undefined;
/**
 * @member {String} order_number
 */

PurchaseOrder.prototype['order_number'] = undefined;
/**
 * @member {module:model/Address} origin_address
 */

PurchaseOrder.prototype['origin_address'] = undefined;
/**
 * @member {String} origin_address_book_entry
 */

PurchaseOrder.prototype['origin_address_book_entry'] = undefined;
/**
 * Origin dock id of the purchase order from the company's external system
 * @member {String} origin_dock_external_id
 */

PurchaseOrder.prototype['origin_dock_external_id'] = undefined;
/**
 * @member {String} origin_stop
 */

PurchaseOrder.prototype['origin_stop'] = undefined;
/**
 * @member {Array.<module:model/StopAlert>} origin_stop_alerts
 */

PurchaseOrder.prototype['origin_stop_alerts'] = undefined;
/**
 * Read-only status of a purchase order that, if no transit_status exists, will describe shipment assignment
 * @member {module:model/PurchaseOrder.OverallStatusEnum} overall_status
 */

PurchaseOrder.prototype['overall_status'] = undefined;
/**
 * @member {Date} planned_delivery_end_datetime
 */

PurchaseOrder.prototype['planned_delivery_end_datetime'] = undefined;
/**
 * @member {Date} planned_delivery_start_datetime
 */

PurchaseOrder.prototype['planned_delivery_start_datetime'] = undefined;
/**
 * @member {Date} planned_pickup_end_datetime
 */

PurchaseOrder.prototype['planned_pickup_end_datetime'] = undefined;
/**
 * @member {Date} planned_pickup_start_datetime
 */

PurchaseOrder.prototype['planned_pickup_start_datetime'] = undefined;
/**
 * @member {String} purchase_order_number
 */

PurchaseOrder.prototype['purchase_order_number'] = undefined;
/**
 * @member {String} shipment
 */

PurchaseOrder.prototype['shipment'] = undefined;
/**
 * @member {module:model/PurchaseOrder.SourceEnum} source
 */

PurchaseOrder.prototype['source'] = undefined;
/**
 * @member {String} source_system_id
 */

PurchaseOrder.prototype['source_system_id'] = undefined;
/**
 * @member {String} status
 */

PurchaseOrder.prototype['status'] = undefined;
/**
 * @member {Number} subtotal_amount
 */

PurchaseOrder.prototype['subtotal_amount'] = undefined;
/**
 * @member {module:model/PurchaseOrder.SubtotalAmountCurrencyEnum} subtotal_amount_currency
 * @default 'USD'
 */

PurchaseOrder.prototype['subtotal_amount_currency'] = 'USD';
/**
 * @member {String} supplier_external_id
 */

PurchaseOrder.prototype['supplier_external_id'] = undefined;
/**
 * @member {String} supplier_name
 */

PurchaseOrder.prototype['supplier_name'] = undefined;
/**
 * @member {Number} tax_amount
 */

PurchaseOrder.prototype['tax_amount'] = undefined;
/**
 * @member {module:model/PurchaseOrder.TaxAmountCurrencyEnum} tax_amount_currency
 * @default 'USD'
 */

PurchaseOrder.prototype['tax_amount_currency'] = 'USD';
/**
 * @member {module:model/PurchaseOrder.TransitStatusEnum} transit_status
 */

PurchaseOrder.prototype['transit_status'] = undefined;
/**
 * @member {module:model/PurchaseOrder.TransitStatusReasonCodeEnum} transit_status_reason_code
 */

PurchaseOrder.prototype['transit_status_reason_code'] = undefined;
/**
 * @member {Date} updated_at
 */

PurchaseOrder.prototype['updated_at'] = undefined;
/**
 * Allowed values for the <code>overall_status</code> property.
 * @enum {String}
 * @readonly
 */

PurchaseOrder['OverallStatusEnum'] = {
  /**
   * value: "ASSIGNED"
   * @const
   */
  "ASSIGNED": "ASSIGNED",

  /**
   * value: "UNASSIGNED"
   * @const
   */
  "UNASSIGNED": "UNASSIGNED",

  /**
   * value: "IN_TRANSIT"
   * @const
   */
  "IN_TRANSIT": "IN_TRANSIT",

  /**
   * value: "DELIVERED"
   * @const
   */
  "DELIVERED": "DELIVERED",

  /**
   * value: "DISPATCHED"
   * @const
   */
  "DISPATCHED": "DISPATCHED",

  /**
   * value: "OUT_FOR_DELIVERY"
   * @const
   */
  "OUT_FOR_DELIVERY": "OUT_FOR_DELIVERY"
};
/**
 * Allowed values for the <code>source</code> property.
 * @enum {String}
 * @readonly
 */

PurchaseOrder['SourceEnum'] = {
  /**
   * value: "MAGENTO"
   * @const
   */
  "MAGENTO": "MAGENTO",

  /**
   * value: "SHIPWELL_WEB"
   * @const
   */
  "SHIPWELL_WEB": "SHIPWELL_WEB",

  /**
   * value: "SHOPIFY"
   * @const
   */
  "SHOPIFY": "SHOPIFY",

  /**
   * value: "IMPORT"
   * @const
   */
  "IMPORT": "IMPORT",

  /**
   * value: "TENDER"
   * @const
   */
  "TENDER": "TENDER",

  /**
   * value: "SHIPWELL_WEB_UNAUTH"
   * @const
   */
  "SHIPWELL_WEB_UNAUTH": "SHIPWELL_WEB_UNAUTH"
};
/**
 * Allowed values for the <code>subtotal_amount_currency</code> property.
 * @enum {String}
 * @readonly
 */

PurchaseOrder['SubtotalAmountCurrencyEnum'] = {
  /**
   * value: "CAD"
   * @const
   */
  "CAD": "CAD",

  /**
   * value: "USD"
   * @const
   */
  "USD": "USD"
};
/**
 * Allowed values for the <code>tax_amount_currency</code> property.
 * @enum {String}
 * @readonly
 */

PurchaseOrder['TaxAmountCurrencyEnum'] = {
  /**
   * value: "CAD"
   * @const
   */
  "CAD": "CAD",

  /**
   * value: "USD"
   * @const
   */
  "USD": "USD"
};
/**
 * Allowed values for the <code>transit_status</code> property.
 * @enum {String}
 * @readonly
 */

PurchaseOrder['TransitStatusEnum'] = {
  /**
   * value: "PICKED_UP"
   * @const
   */
  "PICKED_UP": "PICKED_UP",

  /**
   * value: "IN_TRANSIT"
   * @const
   */
  "IN_TRANSIT": "IN_TRANSIT",

  /**
   * value: "DELIVERED"
   * @const
   */
  "DELIVERED": "DELIVERED",

  /**
   * value: "EXCEPTIONS"
   * @const
   */
  "EXCEPTIONS": "EXCEPTIONS",

  /**
   * value: "CANCELLED"
   * @const
   */
  "CANCELLED": "CANCELLED"
};
/**
 * Allowed values for the <code>transit_status_reason_code</code> property.
 * @enum {String}
 * @readonly
 */

PurchaseOrder['TransitStatusReasonCodeEnum'] = {
  /**
   * value: "ACCIDENT"
   * @const
   */
  "ACCIDENT": "ACCIDENT",

  /**
   * value: "ALTERNATE_CARRIER_DELIVERED"
   * @const
   */
  "ALTERNATE_CARRIER_DELIVERED": "ALTERNATE_CARRIER_DELIVERED",

  /**
   * value: "ALTERNATE_CARRIER_PICKED_UP"
   * @const
   */
  "ALTERNATE_CARRIER_PICKED_UP": "ALTERNATE_CARRIER_PICKED_UP",

  /**
   * value: "AWAITING_IMPORT"
   * @const
   */
  "AWAITING_IMPORT": "AWAITING_IMPORT",

  /**
   * value: "BORDER_CLEARANCE"
   * @const
   */
  "BORDER_CLEARANCE": "BORDER_CLEARANCE",

  /**
   * value: "CARRIER_KEYING_ERROR"
   * @const
   */
  "CARRIER_KEYING_ERROR": "CARRIER_KEYING_ERROR",

  /**
   * value: "CARRIER_RELATED"
   * @const
   */
  "CARRIER_RELATED": "CARRIER_RELATED",

  /**
   * value: "CASH_NOT_AVAILABLE_FROM_CONSIGNEE"
   * @const
   */
  "CASH_NOT_AVAILABLE_FROM_CONSIGNEE": "CASH_NOT_AVAILABLE_FROM_CONSIGNEE",

  /**
   * value: "CIVIL_EVENT"
   * @const
   */
  "CIVIL_EVENT": "CIVIL_EVENT",

  /**
   * value: "COLLECT_ON_DELIVERY_REQUIRED"
   * @const
   */
  "COLLECT_ON_DELIVERY_REQUIRED": "COLLECT_ON_DELIVERY_REQUIRED",

  /**
   * value: "CONSIGNEE_CLOSED"
   * @const
   */
  "CONSIGNEE_CLOSED": "CONSIGNEE_CLOSED",

  /**
   * value: "CONSIGNEE_RELATED"
   * @const
   */
  "CONSIGNEE_RELATED": "CONSIGNEE_RELATED",

  /**
   * value: "CONTAMINATED"
   * @const
   */
  "CONTAMINATED": "CONTAMINATED",

  /**
   * value: "CREDIT_HOLD"
   * @const
   */
  "CREDIT_HOLD": "CREDIT_HOLD",

  /**
   * value: "CUSTOMER_REQUESTED_DIFFERENT_DELIVERY_WINDOW"
   * @const
   */
  "CUSTOMER_REQUESTED_DIFFERENT_DELIVERY_WINDOW": "CUSTOMER_REQUESTED_DIFFERENT_DELIVERY_WINDOW",

  /**
   * value: "CUSTOMS_DOCUMENTATION_PROBLEM"
   * @const
   */
  "CUSTOMS_DOCUMENTATION_PROBLEM": "CUSTOMS_DOCUMENTATION_PROBLEM",

  /**
   * value: "CUSTOMS_DOCUMENTATION_PROBLEMS"
   * @const
   */
  "CUSTOMS_DOCUMENTATION_PROBLEMS": "CUSTOMS_DOCUMENTATION_PROBLEMS",

  /**
   * value: "DAMAGED"
   * @const
   */
  "DAMAGED": "DAMAGED",

  /**
   * value: "DELIVERY_SHORTAGE"
   * @const
   */
  "DELIVERY_SHORTAGE": "DELIVERY_SHORTAGE",

  /**
   * value: "DRIVER_NOT_AVAILABLE"
   * @const
   */
  "DRIVER_NOT_AVAILABLE": "DRIVER_NOT_AVAILABLE",

  /**
   * value: "DRIVER_RELATED"
   * @const
   */
  "DRIVER_RELATED": "DRIVER_RELATED",

  /**
   * value: "EQUIPMENT_SHORTAGE"
   * @const
   */
  "EQUIPMENT_SHORTAGE": "EQUIPMENT_SHORTAGE",

  /**
   * value: "EQUIPMENT_VOLUME_NOT_AVAILABLE"
   * @const
   */
  "EQUIPMENT_VOLUME_NOT_AVAILABLE": "EQUIPMENT_VOLUME_NOT_AVAILABLE",

  /**
   * value: "EXCEEDS_SERVICE_LIMITATIONS"
   * @const
   */
  "EXCEEDS_SERVICE_LIMITATIONS": "EXCEEDS_SERVICE_LIMITATIONS",

  /**
   * value: "FAILED_TO_RELEASE_BILLING"
   * @const
   */
  "FAILED_TO_RELEASE_BILLING": "FAILED_TO_RELEASE_BILLING",

  /**
   * value: "HELD_FOR_FULL_CARRIER_LOAD"
   * @const
   */
  "HELD_FOR_FULL_CARRIER_LOAD": "HELD_FOR_FULL_CARRIER_LOAD",

  /**
   * value: "HELD_FOR_PAYMENT"
   * @const
   */
  "HELD_FOR_PAYMENT": "HELD_FOR_PAYMENT",

  /**
   * value: "HELD_FOR_PROTECTIVE_SERVICE"
   * @const
   */
  "HELD_FOR_PROTECTIVE_SERVICE": "HELD_FOR_PROTECTIVE_SERVICE",

  /**
   * value: "HELD_PENDING_APPOINTMENT"
   * @const
   */
  "HELD_PENDING_APPOINTMENT": "HELD_PENDING_APPOINTMENT",

  /**
   * value: "HOLIDAY_CLOSED"
   * @const
   */
  "HOLIDAY_CLOSED": "HOLIDAY_CLOSED",

  /**
   * value: "IMPROPER_FACILITY_OR_EQUIPMENT"
   * @const
   */
  "IMPROPER_FACILITY_OR_EQUIPMENT": "IMPROPER_FACILITY_OR_EQUIPMENT",

  /**
   * value: "IMPROPER_TEMPERATURE"
   * @const
   */
  "IMPROPER_TEMPERATURE": "IMPROPER_TEMPERATURE",

  /**
   * value: "INCONSISTENT_WEIGHT"
   * @const
   */
  "INCONSISTENT_WEIGHT": "INCONSISTENT_WEIGHT",

  /**
   * value: "INCORRECT_ADDRESS"
   * @const
   */
  "INCORRECT_ADDRESS": "INCORRECT_ADDRESS",

  /**
   * value: "INSUFFICIENT_DELIVERY_TIME"
   * @const
   */
  "INSUFFICIENT_DELIVERY_TIME": "INSUFFICIENT_DELIVERY_TIME",

  /**
   * value: "INSUFFICIENT_PICKUP_TIME"
   * @const
   */
  "INSUFFICIENT_PICKUP_TIME": "INSUFFICIENT_PICKUP_TIME",

  /**
   * value: "INSUFFICIENT_TRAVEL_TIME_DETECTED"
   * @const
   */
  "INSUFFICIENT_TRAVEL_TIME_DETECTED": "INSUFFICIENT_TRAVEL_TIME_DETECTED",

  /**
   * value: "INTERNATIONAL_NON_CARRIER_DELAY"
   * @const
   */
  "INTERNATIONAL_NON_CARRIER_DELAY": "INTERNATIONAL_NON_CARRIER_DELAY",

  /**
   * value: "MECHANICAL_BREAKDOWN"
   * @const
   */
  "MECHANICAL_BREAKDOWN": "MECHANICAL_BREAKDOWN",

  /**
   * value: "MISSING_DOCUMENTS"
   * @const
   */
  "MISSING_DOCUMENTS": "MISSING_DOCUMENTS",

  /**
   * value: "MIS_SORT"
   * @const
   */
  "MIS_SORT": "MIS_SORT",

  /**
   * value: "NON_EXPRESS_CLEARANCE_DELAY"
   * @const
   */
  "NON_EXPRESS_CLEARANCE_DELAY": "NON_EXPRESS_CLEARANCE_DELAY",

  /**
   * value: "NORMAL_APPOINTMENT"
   * @const
   */
  "NORMAL_APPOINTMENT": "NORMAL_APPOINTMENT",

  /**
   * value: "NORMAL_STATUS"
   * @const
   */
  "NORMAL_STATUS": "NORMAL_STATUS",

  /**
   * value: "NO_APPOINTMENT_SCHEDULED"
   * @const
   */
  "NO_APPOINTMENT_SCHEDULED": "NO_APPOINTMENT_SCHEDULED",

  /**
   * value: "NO_REQUESTED_ARRIVAL_DATE_OR_TIME"
   * @const
   */
  "NO_REQUESTED_ARRIVAL_DATE_OR_TIME": "NO_REQUESTED_ARRIVAL_DATE_OR_TIME",

  /**
   * value: "OTHER"
   * @const
   */
  "OTHER": "OTHER",

  /**
   * value: "PAST_CUT_OFF_TIME"
   * @const
   */
  "PAST_CUT_OFF_TIME": "PAST_CUT_OFF_TIME",

  /**
   * value: "PROCESSING_DELAY"
   * @const
   */
  "PROCESSING_DELAY": "PROCESSING_DELAY",

  /**
   * value: "RAILROAD_FAILED_TO_MEET_SCHEDULE"
   * @const
   */
  "RAILROAD_FAILED_TO_MEET_SCHEDULE": "RAILROAD_FAILED_TO_MEET_SCHEDULE",

  /**
   * value: "RECIPIENT_UNAVAILABLE"
   * @const
   */
  "RECIPIENT_UNAVAILABLE": "RECIPIENT_UNAVAILABLE",

  /**
   * value: "RECONSIGNED"
   * @const
   */
  "RECONSIGNED": "RECONSIGNED",

  /**
   * value: "RESTRICTED_ARTICLES_UNACCEPTABLE"
   * @const
   */
  "RESTRICTED_ARTICLES_UNACCEPTABLE": "RESTRICTED_ARTICLES_UNACCEPTABLE",

  /**
   * value: "RETURNED_TO_SHIPPER"
   * @const
   */
  "RETURNED_TO_SHIPPER": "RETURNED_TO_SHIPPER",

  /**
   * value: "ROAD_CONDITIONS"
   * @const
   */
  "ROAD_CONDITIONS": "ROAD_CONDITIONS",

  /**
   * value: "SHIPMENT_OVERWEIGHT"
   * @const
   */
  "SHIPMENT_OVERWEIGHT": "SHIPMENT_OVERWEIGHT",

  /**
   * value: "SHIPPER_RELATED"
   * @const
   */
  "SHIPPER_RELATED": "SHIPPER_RELATED",

  /**
   * value: "TRACKING_EVENT_AUTOMATED_CALL"
   * @const
   */
  "TRACKING_EVENT_AUTOMATED_CALL": "TRACKING_EVENT_AUTOMATED_CALL",

  /**
   * value: "TRACKING_EVENT_EDI_UPDATE"
   * @const
   */
  "TRACKING_EVENT_EDI_UPDATE": "TRACKING_EVENT_EDI_UPDATE",

  /**
   * value: "TRACKING_EVENT_ELD_UPDATE"
   * @const
   */
  "TRACKING_EVENT_ELD_UPDATE": "TRACKING_EVENT_ELD_UPDATE",

  /**
   * value: "TRACKING_EVENT_GEOFENCE_BREACH"
   * @const
   */
  "TRACKING_EVENT_GEOFENCE_BREACH": "TRACKING_EVENT_GEOFENCE_BREACH",

  /**
   * value: "TRACKING_EVENT_MANUAL_LOCATION_UPDATED"
   * @const
   */
  "TRACKING_EVENT_MANUAL_LOCATION_UPDATED": "TRACKING_EVENT_MANUAL_LOCATION_UPDATED",

  /**
   * value: "TRACKING_EVENT_MOBILE_APP"
   * @const
   */
  "TRACKING_EVENT_MOBILE_APP": "TRACKING_EVENT_MOBILE_APP",

  /**
   * value: "TRACKING_EVENT_MOBILE_APP_UPDATED_BY_DRIVER"
   * @const
   */
  "TRACKING_EVENT_MOBILE_APP_UPDATED_BY_DRIVER": "TRACKING_EVENT_MOBILE_APP_UPDATED_BY_DRIVER",

  /**
   * value: "TRAIN_DERAILMENT"
   * @const
   */
  "TRAIN_DERAILMENT": "TRAIN_DERAILMENT",

  /**
   * value: "UNABLE_TO_CONTACT_RECIPIENT"
   * @const
   */
  "UNABLE_TO_CONTACT_RECIPIENT": "UNABLE_TO_CONTACT_RECIPIENT",

  /**
   * value: "UNABLE_TO_LOCATE"
   * @const
   */
  "UNABLE_TO_LOCATE": "UNABLE_TO_LOCATE",

  /**
   * value: "UNKNOWN"
   * @const
   */
  "UNKNOWN": "UNKNOWN",

  /**
   * value: "WAITING_FOR_CUSTOMER_PICKUP"
   * @const
   */
  "WAITING_FOR_CUSTOMER_PICKUP": "WAITING_FOR_CUSTOMER_PICKUP",

  /**
   * value: "WAITING_INSPECTION"
   * @const
   */
  "WAITING_INSPECTION": "WAITING_INSPECTION",

  /**
   * value: "WAITING_SHIPPING_INSTRUCTIONS"
   * @const
   */
  "WAITING_SHIPPING_INSTRUCTIONS": "WAITING_SHIPPING_INSTRUCTIONS",

  /**
   * value: "WEATHER_OR_NATURAL_DISASTER"
   * @const
   */
  "WEATHER_OR_NATURAL_DISASTER": "WEATHER_OR_NATURAL_DISASTER"
};
var _default = PurchaseOrder;
exports["default"] = _default;